module.exports = __webpack_public_path__ + "static/media/camera-alt.d2bf5bed.svg";